'use client'

import { useEffect, useRef, useState } from 'react'
import { isFirefox } from 'react-device-detect'
import { Reveal } from 'react-awesome-reveal'
import classNames from 'classnames'
import throttle from 'lodash.throttle'

import { RevealTextProps } from './RevealText.schema'

const RevealText = (props: RevealTextProps) => {
    const headingRef = useRef<HTMLDivElement>(null)

    const [numberOfLines, setNumberOfLines] = useState(1)
    const [isVisible, setIsVisible] = useState(false)
    const [lineHeight, setLineHeight] = useState(1)
    const [isAnimationActive, setIsAnimationActive] = useState(false)

    const HeadingElement = props.headingElement || 'h1'

    const className = classNames(
        'reveal-text',
        `reveal-text--${props.backgroundColor || 'white'}`,
        props.className,
        isVisible && 'is-visible',
        isAnimationActive && 'is-animation-active'
    )

    const onVisibilityChange = (inView: boolean) => {
        if (inView && !isVisible) {
            setIsVisible(true)
        }
    }

    useEffect(() => {
        const calculateNumberOfLines = throttle(() => {
            if (headingRef.current) {
                const parsedLineHeight = parseFloat(window.getComputedStyle(headingRef.current).lineHeight) + 2

                setLineHeight(parsedLineHeight)

                const elementHeight = headingRef.current.offsetHeight

                setNumberOfLines(Math.round(elementHeight / parsedLineHeight))

                requestAnimationFrame(() => setIsAnimationActive(true))
            }
        }, 10)

        window.addEventListener('resize', calculateNumberOfLines)
        calculateNumberOfLines()

        return () => {
            window.removeEventListener('resize', calculateNumberOfLines)
        }
    }, [headingRef])

    return (
        <HeadingElement
            className={className}
            ref={headingRef}
        >
            <Reveal className='reveal-text__reveal' onVisibilityChange={onVisibilityChange} triggerOnce> </Reveal>
            <div
                className="reveal-text__inner"
                style={{ transform: `translateY(${lineHeight}px)` }}
            >
                <div dangerouslySetInnerHTML={{ __html: props.text.replace(/<(?!mark|\/mark)[^>]+>/ig, '') }} />
                {Array.from(Array(numberOfLines).keys()).map((_value, index) => (
                    <div
                        key={index}
                        className='reveal-text__cover'
                        style={{
                            height: lineHeight + 'px',
                            bottom: lineHeight * index - 1 - (isFirefox ? 0 : (lineHeight * .035 * index)) + 'px',
                        }}
                    />
                ))}
            </div>
        </HeadingElement>
    )
}

export default RevealText